import { combineReducers } from "redux";
import loader from "../loader";
import languge from "../language";
import localizationReducer from "../localization";
import auth from "../auth";

const reducers = combineReducers({
  loader: loader.reducers,
  locale: localizationReducer,
  language: languge.reducers,
  auth: auth.reducers,
});

export default reducers;
